<template>
    <div class="max-width-content">
        <breadcrumbs>
            <inertia-link href="/jobtemplates">Banen</inertia-link>
            <i class="fad fa-chevron-right"></i>
            Nieuw baan aanmaken
        </breadcrumbs>

        <div class="flex justify-between items-center">
            <div class="flex ">
                <h1 class="text-5xl text-teal-800 mr-1">Nieuw baan aanmaken</h1>
            </div>
        </div>
        <div class="bg-white rounded-lg p-5">
            <job-template-form :categories="categories" @submit="submit" :data-loading="loading"></job-template-form>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import JobTemplateForm from "@/admin/Pages/JobTemplates/JobTemplateForm";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";

export default {
    metaInfo() {
        return { title: "Baan aanmaken" };
    },

    mixins: [Helpers],

    layout: (h, page) => h(Layout, [page]),

    components: {
        Breadcrumbs,
        JobTemplateForm
    },

    props: {
        categories: Array
    },

    data() {
        return {};
    },

    methods: {
        submit(data) {
            this.loading = "submit";
            const url = this.route("admin.jobtemplates.store").url();

            const options = {
                onFinish: () => {
                    this.loading = false;
                }

            }

            this.$inertia.post(url, data, options)
        }
    }
};
</script>
